import React from "react";
import { Alert, Col, Row } from "react-bootstrap";
import { TitleWMutedRow } from "../atoms";
import { SitelHelpDeskLanguage } from "../atoms/contactPhones/sitelHelpDesk";

const ErrorComponent = ({language}) => (
  <>
  <TitleWMutedRow muted={language.mutedTitle}>{language.title}</TitleWMutedRow>
  <Row>
      <Col>
          <Alert variant="danger">
              <Alert.Heading>Error - Not Found</Alert.Heading>
              <p>
                  We're sorry, but we cannot locate your account's profile. <br/>
              </p>
              <hr />
              <p>
                {
                    SitelHelpDeskLanguage()
                }
              </p>
          </Alert>
      </Col>
  </Row>
</>
);

export default ErrorComponent;
